require('./bootstrap');


Vue.component('example', require('./components/Example.vue'));
Vue.component('panel-search', require('./components/PanelSearch.vue'));
Vue.component('select-users', require('./components/SelectUsers.vue'));
Vue.component('list-supervisors', require('./components/ListSupervisors.vue'));
Vue.component('tabs-supervisors', require('./components/TabsSupervisors.vue'));
Vue.component('show-supervisor', require('./components/ShowSupervisor.vue'));
Vue.component('show-supervisor-admin', require('./components/ShowSupervisorAdmin.vue'));
Vue.component('search-car-supervisor', require('./components/SearchCarSupervisor.vue'));
Vue.component('statistic-supervisor', require('./components/StatisticSupervisor.vue'));
Vue.component('salon-form-image', require('./components/SalonFormImage.vue'));
Vue.component('list-users', require('./components/ListUsers.vue'));
Vue.component('tabs-users', require('./components/TabsUsers.vue'));
Vue.component('list-salons', require('./components/ListSalons.vue'));
Vue.component('list-groups', require('./components/ListGroups.vue'));
Vue.component('select-salons', require('./components/SelectSalons.vue'));
Vue.component('list-approved-login-requests', require('./components/ListApprovedLoginRequests.vue'));
Vue.component('tabs-stocks', require('./components/TabsStocks.vue'));
Vue.component('list-inspections', require('./components/ListInspections.vue'));
Vue.component('list-inspections-user', require('./components/ListInspectionsUser.vue'));
Vue.component('tabs-inspection', require('./components/TabsInspection.vue'));
Vue.component('inspection-main', require('./components/InspectionMain.vue'));
Vue.component('inspection-equipment', require('./components/InspectionEquipment.vue'));
Vue.component('inspection-external', require('./components/InspectionExternal.vue'));
Vue.component('inspection-external-unmarked', require('./components/InspectionExternalUnmarked.vue'));
Vue.component('inspection-external-unmeasurable', require('./components/InspectionExternalUnmeasurable.vue'));
Vue.component('inspection-internal', require('./components/InspectionInternal.vue'));
Vue.component('inspection-test-drive', require('./components/InspectionTestDrive.vue'));
Vue.component('inspection-diagnostic', require('./components/InspectionDiagnostic.vue'));
Vue.component('svg-map', require('./components/SvgMap.vue'));
Vue.component('date-picker', require('./components/DatePicker.vue'));
Vue.component('tabs-required-fields', require('./components/TabsRequiredFields.vue'));

const moment = require('moment');
moment.locale('ru');
Vue.filter('date_format', (date, format) => moment(date).format(format))

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCk4xuL5LZ_q8MunoF741zIQ49-3hqjc54'
        // libraries: 'places', //// If you need to use place input
    }
});
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-marker', VueGoogleMaps.Marker);
Vue.component('google-cluster', VueGoogleMaps.Cluster);

require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ru');
$.fn.datepicker.defaults.language = 'ru';

const app = new Vue({
    el: '#app'
});



// WEBPACK FOOTER //
// resources/assets/js/app.js